import { WpNonCompliance} from './wp-non-compliance.model';


export class NonComplianceSummary {
  constructor(

        public referralId?: number,
        public personId?: number,
        public assignedTo?: number,
        public wpNonComplianceList?:WpNonCompliance[],
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/non-compliance-summary-model.ts